export const storagekeys = {
  requestFilters: '@guacu-filters',
  actualPage: '@pagination'
}

export default storagekeys